import {
  LIST_RESULT_CONCLUSION_LIBRARY_REQUEST,
  LIST_RESULT_CONCLUSION_LIBRARY_SUCCESS,
  LIST_RESULT_CONCLUSION_LIBRARY_FAIL,
  LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_REQUEST,
  LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_SUCCESS,
  LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_FAIL,
  CREATE_RESULT_CONCLUSION_LIBRARY_REQUEST,
  CREATE_RESULT_CONCLUSION_LIBRARY_SUCCESS,
  CREATE_RESULT_CONCLUSION_LIBRARY_FAIL,
  UPDATE_RESULT_CONCLUSION_LIBRARY_REQUEST,
  UPDATE_RESULT_CONCLUSION_LIBRARY_SUCCESS,
  UPDATE_RESULT_CONCLUSION_LIBRARY_FAIL,
  DELETE_RESULT_CONCLUSION_LIBRARY_REQUEST,
  DELETE_RESULT_CONCLUSION_LIBRARY_SUCCESS,
  DELETE_RESULT_CONCLUSION_LIBRARY_FAIL,
  DETAIL_RESULT_CONCLUSION_LIBRARY_REQUEST,
  DETAIL_RESULT_CONCLUSION_LIBRARY_SUCCESS,
  DETAIL_RESULT_CONCLUSION_LIBRARY_FAIL
} from '../../constants/result-conclusion-libraries'

const initialState = {
  loading: false,
  resultConclusionLibraries: [],
  resultConclusionLibrariesSummary: [],
  resultConclusionLibrary: {},
  pageable: {
    page: 1,
    size: 10
  },
  loadingCreate: false,
  loadingDetail: false,
  loadingUpdate: false,
  error: null
}

const resultConclusionLibraryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_RESULT_CONCLUSION_LIBRARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        ressultConclusionLibraries: []
      }
    case LIST_RESULT_CONCLUSION_LIBRARY_SUCCESS:
      return {
        ...state,
        loading: false,
        resultConclusionLibraries: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_RESULT_CONCLUSION_LIBRARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        resultConclusionLibraries: action?.dummy
      }
    case LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        resultConclusionLibrariesSummary: action.payload
      }
    case LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_RESULT_CONCLUSION_LIBRARY_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_RESULT_CONCLUSION_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        resultConclusionLibraries: [
          ...state.resultConclusionLibraries,
          action.payload
        ]
      }
    case CREATE_RESULT_CONCLUSION_LIBRARY_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_RESULT_CONCLUSION_LIBRARY_REQUEST:
      return { ...state, loadingDetail: true, resultConclusionLibrary: {} }
    case DETAIL_RESULT_CONCLUSION_LIBRARY_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        resultConclusionLibrary: action.payload
      }
    case DETAIL_RESULT_CONCLUSION_LIBRARY_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        resultConclusionLibrary: {}
      }
    case UPDATE_RESULT_CONCLUSION_LIBRARY_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_RESULT_CONCLUSION_LIBRARY_SUCCESS:
      const updatedResultConclusionLibrary = action.payload
      const updateFindIndexResultConclusionLibrary =
        state.resultConclusionLibraries.findIndex(
          (title) => title.id === updatedResultConclusionLibrary.id
        )
      const updatedResultConclusionLibraries = [
        ...state.resultConclusionLibraries
      ]
      updatedResultConclusionLibraries[updateFindIndexResultConclusionLibrary] =
        updatedResultConclusionLibrary

      return {
        ...state,
        loadingUpdate: false,
        resultConclusionLibraries: updatedResultConclusionLibraries
      }
    case UPDATE_RESULT_CONCLUSION_LIBRARY_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_RESULT_CONCLUSION_LIBRARY_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_RESULT_CONCLUSION_LIBRARY_SUCCESS:
      const deletedResultConclusionLibraryId = action.payload
      const deletedFindIndexResultConclusionLibrary =
        state.resultConclusionLibraries.findIndex(
          (title) => title.id === deletedResultConclusionLibraryId
        )
      const deletedResultConclusionLibrarys = [
        ...state.resultConclusionLibraries
      ]
      deletedResultConclusionLibrarys.splice(
        deletedFindIndexResultConclusionLibrary,
        1
      )

      return {
        ...state,
        loadingDelete: false,
        resultConclusionLibraries: deletedResultConclusionLibrarys
      }
    case DELETE_RESULT_CONCLUSION_LIBRARY_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default resultConclusionLibraryReducer
